<section class="d-flex flex-column flex-grow-1">
  <p class="text-center text-uppercase title mb-1">{{ 'page2Header' | translate }}</p>
  <p class="subtitle">{{ 'page2subHeader' | translate }}</p>

  <form [formGroup]="form" class="d-flex flex-column flex-grow-1" (ngSubmit)="submitForm()">
    <div class="form-group form-group-default form-group-default-select m-t-10" [class.focused]="focused() === 'country'">
      <label for="country">{{ 'labels.country' | translate }}</label>
      <select
        name="country"
        id="country"
        class="form-control"
        formControlName="country"
        (focus)="focused.set('country')"
        (blur)="focused.set(null)"
      >
        <option disabled value="">-- select an option --</option>
        @for (country of countries(); track country.code) {
          <option [value]="country.code.toLowerCase()">{{ country.name }}</option>
        }
      </select>
    </div>
    @if (isCountryError()) {
      <p class="error-field">{{ 'errors.notInThisCountry' | translate }}</p>
    }
    @if (showTimezoneSelect()) {
      <div class="form-group form-group-default form-group-default-select" [class.focused]="focused() === 'timeZone'">
        <label class="field-require text-uppercase" for="timeZone">{{ 'labels.timeZone' | translate }}</label>
        <select id="timeZone" class="form-control" formControlName="timeZone" (focus)="focused.set('timeZone')" (blur)="focused.set(null)">
          <option value="" disabled hidden>-- select an option --</option>
          @for (zone of zones() ?? allZones(); track zone.key) {
            <option [value]="zone.key">{{ zone.value }} - {{ zone.key }}</option>
          }
        </select>
      </div>
    }
    <div
      class="form-group form-group-default form-group-default-select"
      [class.focused]="focused() === 'businessSector'"
      [class.has-error]="form.controls.businessSector.touched && form.controls.businessSector.invalid"
    >
      <label for="businessSector" class="text-uppercase mb-0">
        {{ 'labels.bussinessSector' | translate }} {{ 'labels.bussinessSectorSubTitle' | translate }}
      </label>
      <select
        name="businessSector"
        id="businessSector"
        class="form-control"
        formControlName="businessSector"
        (focus)="focused.set('businessSector')"
        (blur)="focused.set(null)"
      >
        <option disabled value="">{{ 'labels.selectOne' | translate }}</option>
        @for (sector of sectors; track sector) {
          <option [value]="sector">{{ 'labels.' + (sector[0].toUpperCase() + sector.slice(1)) | translate }}</option>
        }
      </select>
    </div>
    <app-error-displayer [control]="form.controls.businessSector" />

    <app-vc-input
      name="website"
      label="labels.businessWebsite"
      [control]="form.controls.website"
      placeholder="e.g. www.some.business.com"
      autocomplete="url"
      (enter)="submitForm()"
    />
    <app-company-domain-sync [companyName]="form.controls.companyName" [domain]="form.controls.domain" (enter)="submitForm()" />

    @if (turnstileEnabled) {
      <app-turnstile (token)="onTurnstileToken($event)" />
    }
    @if (turnstileError()) {
      <p class="error-field">{{ 'errors.securityCheck' | translate }}</p>
    }

    @if (show500()) {
      <app-error500 (closed)="show500.set(false)" />
    }

    <div class="mt-auto">
      <div class="clearfix button-mobile-w-100 d-flex flex-column flex-sm-row">
        <button
          type="button"
          class="btn btn-lg btn-default mr-sm-1 mb-1 mb-sm-0 col-sm-3 btn-bck"
          [disabled]="submitting()"
          (click)="back.emit()"
        >
          &lt; {{ 'labels.back' | translate }}
        </button>
        <button
          type="submit"
          class="btn btn-lg flex-grow-1"
          [class.btn-primary]="form.valid || form.disabled"
          [class.btn-default]="!(form.valid || form.disabled)"
          [disabled]="submitting()"
        >
          <span>{{ 'labels.letsStart' | translate }}</span>
          @if (submitting()) {
            <img src="/assets/img/spinner.svg" width="12" height="12" alt="" />
          }
        </button>
      </div>
    </div>

    <div class="footer-text">
      <div class="col-12 small-text text-center">
        <span>{{ 'labels.agreement1' | translate }}</span><br />
        <a class="text-primary" [href]="termsUrl()" target="_blank" rel="noopener">{{ 'labels.agreement2' | translate }} </a>
        <span> {{ 'labels.agreement23and' | translate }} </span>
        <a class="text-primary" [href]="cookiePolicyUrl()" target="_blank" rel="noopener">{{ 'labels.agreement3' | translate }} </a>.
      </div>
    </div>
  </form>
</section>
